import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    switchButton: {
        fontWeight: 700,
        size: "18px",
        color: "white",
        alignSelf: "left",
    },
    toggle: {
        '& .Mui-checked': {
            color: theme.palette.secondary.main
        },
        '& .MuiSwitch-thumb': {
            color: theme.palette.secondary.main
        },
         '& .MuiSwitch-track': {
            backgroundColor: theme.palette.secondary.main
         }
      }
}), {index: 1});

